import React from 'react';

interface BadgeProps {
  text: string;
}

export const Badge: React.FC<BadgeProps> = ({ text }) => (
  <span className="border border-navy/20 text-navy text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-pill whitespace-nowrap">
    {text}
  </span>
);
